import Icon from '@icon/Icon';

const Play = (props) => {
  const { color, ...rest } = props;

  return (
    <Icon {...rest} viewBox="0 0 13 13">
      <path
        d="M12.0534 8.26493C12.8799 7.62536 12.8799 6.37748 12.0534 5.73791C9.5554 3.80508 6.76607 2.28162 3.78978 1.22455L3.24605 1.03144C2.20583 0.66199 1.10707 1.36579 0.966242 2.43958C0.572776 5.43976 0.572776 8.56308 0.966242 11.5633C1.10707 12.637 2.20583 13.3409 3.24605 12.9714L3.78978 12.7783C6.76606 11.7212 9.5554 10.1978 12.0534 8.26493Z"
        fill={color}
      />
    </Icon>
  );
};

export default Play;
